import request from "@/utils/request";

export async function getVendorList(needChildVendorFlag) {
  //获取买手店列表
  return (
    await request({
      url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller`,
      method: "post",
      data: {
        needChildVendorFlag,
      },
    })
  ).data;
}
export async function checkSpuIds(data) {
  //校验spuIds是否无效
  return (
    await request({
      url: `/sc-basic-merchant-backend/top/spu/manager/checkSpuIds`,
      method: "post",
      data,
    })
  ).data;
}
export async function delSpuManager(data) {
  //退出个人卖家商品池
  return (
    await request({
      url: `/sc-basic-merchant-backend/top/spu/manager/del`,
      method: "post",
      data,
    })
  ).data;
}
export async function addSpuManager(data) {
  //添加到个人卖家商品池
  return (
    await request({
      url: `/sc-basic-merchant-backend/top/spu/manager/add`,
      method: "post",
      data,
    })
  ).data;
}
export async function getManagerList(data) {
  //获取列表
  return (
    await request({
      url: `/sc-basic-merchant-backend/top/spu/manager/list`,
      method: "post",
      data,
    })
  ).data;
}


export async function getCategory() {
  // 获取商品类目树接口
  return (
    await request({
      // url: `/procurement-service/restapi/im/base/data/category`,
      url: `/basic-backend/category/tree`,
      method: "get",
    })
  ).data;
}
export async function getSeasonList() {
  //季节列表
  return (
    await request({
      url: `/product-service/season/list `,
      method: "get",
    })
  ).data;
}

export async function getBrandList() {
  //品牌列表
  return (
    await request({
      url: `/product-service/brand/list`,
      method: "get",
    })
  ).data;
}

export async function getSellerApplyList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/apply/list`,
    method: "post",
    data,
  });
}
export function exportSellerApply(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/apply/import`,
    method: "post",
    data,
  });
}

export function updateSellerApplyStatus(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/apply/update/status`,
    method: "post",
    data,
  });
}

export function getDictByCode(params) {
  return request({
    url: `/sc-basic-merchant-backend/seller/apply/dictByCode`,
    params,
  });
}

export const importUrl =
  process.env.VUE_APP_BASE_URL +
  "sc-basic-merchant-backend/sellerVendorBdRelation/import";
export const spuImportUrl =
  process.env.VUE_APP_BASE_URL +
  "sc-basic-merchant-backend/top/spu/manager/import";

///seller/identity/auth/list 审核列表,支持待审核,已审核
export async function getIdentityAuthList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/identity/auth/list`,
      method: "post",
      data,
    })
  ).data;
}

///seller/vendor/create 个人卖家-开通店铺
export async function sellerVendorCreate(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/vendor/create`,
      method: "post",
      data,
    })
  ).data;
}
///seller/identity/auth/remarks 个人卖家-添加备注
export async function identityAuthRemarks(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/identity/auth/remarks`,
      method: "PUT",
      data,
    })
  ).data;
}

export function exportSeller(params) {
  return request({
    url: "/sc-basic-merchant-backend/seller/identity/auth/export",
    method: "get",
    params,
    responseType: "blob",
  });
}

export async function getNoticeList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/cms/list`,
    method: "post",
    data,
  });
}

export async function getNoticeDetail(params) {
  return await request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/cms/detail`,
    method: "get",
    params,
  });
}

export async function addOrUpdateNotice(data) {
  return await request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/addOrUpdate`,
    method: "post",
    data,
  });
}

export async function disabledNotice(params) {
  return await request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/disabled`,
    method: "get",
    params,
  });
}

export async function topNotice(params) {
  return await request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/top`,
    method: "get",
    params,
  });
}

export function fileUpload() {
  return request({
    url: `/oss/file-upload-auth-sts`,
    method: "GET",
  });
}

export async function authConfirm(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/identity/auth/confirm`,
    method: "post",
    data,
  });
}

export async function getMobile(appUserId) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/identity/auth/mobile?appUserId=${appUserId}`,
  });
}

export async function getIdCardImg(sellerIdentityAuthId, type) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/identity/auth/idCard/img?sellerIdentityAuthId=${sellerIdentityAuthId}&type=${type}`,
  });
}

export async function rejectSeller(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/identity/auth/reject`,
    method: "post",
    data,
  });
}

export async function saveSellerSearchTop(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/search/top/import`,
    method: "post",
    data,
  });
}

export async function getSellerSearchTop() {
  return await request({
    url: `/sc-basic-merchant-backend/seller/search/top`,
  });
}

export async function queryImageInfo(url) {
  return await request({
    url: `${url}?x-oss-process=image/info`,
  });
}

export async function saveSellerAlertSPU(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/spu/config/import`,
    method: "post",
    data,
  });
}

export async function getSellerAlertSPU() {
  return await request({
    url: `/sc-basic-merchant-backend/seller/spu/config`,
  });
}

export async function getFeedbackList(params) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/suggest/feedback/list`,
    params,
  });
}

export async function submitFeedbackProcess(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/suggest/feedback/process/submit`,
    method: "post",
    data,
  });
}

export async function getContactPhoneNum(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/suggest/feedback/getContactPhoneNum`,
    method: "post",
    data,
  });
}

export async function exportFeedbackList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/suggest/feedback/export`,
    method: "post",
    data,
  });
}

export async function getServiceFeeUser() {
  return await request({
    url: `/sc-basic-merchant-backend/seller/service-fee/user`,
  });
}

export async function importServiceFeeUser(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/service-fee/user/import`,
    method: "post",
    data,
  });
}

export async function getSellerUserList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/user/list`,
    method: "post",
    data,
  });
}

export async function exportSellerUserList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/user/export`,
    method: "post",
    data,
  });
}

export async function getQCStandardList(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/qc-standard/list`,
    method: "post",
    data,
  });
}

export async function createQCStandard(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/qc-standard/create`,
    method: "post",
    data,
  });
}

export async function updateQCStandard(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/qc-standard/update`,
    method: "post",
    data,
  });
}

export async function deleteQCStandard(id) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/qc-standard/${id}`,
    method: "delete",
  });
}

export async function getQCStandard(id) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/qc-standard/${id}`,
  });
}

export async function updateVendorStatus(data) {
  return await request({
    url: `/sc-basic-merchant-backend/crm/prepare/updateVendorStatus`,
    method: "post",
    data,
  });
}

export async function updateSellerStatus(data) {
  return await request({
    url: `/sc-basic-merchant-backend/seller/user/updateSellerStatus`,
    method: "post",
    data,
  });
}

export async function getSellerServiceFeePromotionList(params) {
  return request({
    url: `/sc-basic-merchant-backend/seller/service-fee-campaign/list`,
    params,
  });
}

export async function getSellerServiceFeePromotion(id) {
  return request({
    url: `/sc-basic-merchant-backend/seller/service-fee-campaign?id=${id}`,
  });
}

export async function saveSellerServiceFeePromotion(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/service-fee-campaign/save`,
    method: "post",
    data,
  });
}

export async function getSellerCampaignPopoverList(params) {
  return request({
    url: `/sc-basic-merchant-backend/seller/campaign-popover/list`,
    params,
  });
}

export async function getSellerCampaignPopover(id) {
  return request({
    url: `/sc-basic-merchant-backend/seller/campaign-popover?id=${id}`,
  });
}

export async function saveSellerCampaignPopover(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/campaign-popover/save`,
    method: "post",
    data,
  });
}

export async function getSellerNoticeList() {
  return request({
    url: `/sc-basic-merchant-backend/manager/seller/notice/drop-down/list`,
  });
}

export async function getQuestionnaireList(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/questionnaire/list`,
    method: "post",
    data,
  });
}

export async function questionnaireRemark(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/questionnaire/remark`,
    method: "post",
    data,
  });
}

export async function exportQuestionnaireList(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/questionnaire/export`,
    method: "post",
    data,
  });
}

export async function bindUserCampaign(data) {
  return request({
    url: `/sc-basic-merchant-backend/seller/campaign-popover/bindUserCampaign`,
    method: "post",
    data,
  });
}

export async function getRuleSectorList(params) {
  //规则板块列表接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/sector/list`,
    params,
  });
}

export async function getRuleList(data) {
  //规则列表接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/list`,
    method: "post",
    data,
  });
}

export async function getRuleDetail(params) {
  //规则详情接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/detail`,
    params,
  });
}
export async function ruleSave(data) {
  //保存规则接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/save`,
    method: "post",
    data,
  });
}

export async function ruleUpate(data) {
  //置顶/禁用规则接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/patch-update`,
    method: "post",
    data,
  });
}

export async function moveRule(data) {
  //拖拽顺序接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/move`,
    method: "post",
    data,
  });
}

export async function batchMoveRules(data) {
  //拖拽顺序接口
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/batchMove`,
    method: "post",
    data,
  });
}

export async function docxToHtml(data) {
  // word文件转html
  return request({
    url: `/sc-basic-merchant-backend/seller/house-rule/convert/docxToHtml`,
    method: "post",
    data,
  });
}

export async function getSellerNoReasonAfterSaleConfigBrandList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/brand/list`,
      method: "post",
      data,
    })
  ).data;
}

export async function saveSellerNoReasonAfterSaleConfigBrand(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/brand/save`,
      method: "post",
      data,
    })
  ).data;
}

export async function updateSellerNoReasonAfterSaleConfigBrand(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/brand/update`,
      method: "post",
      data,
    })
  ).data;
}

export async function removeSellerNoReasonAfterSaleConfigBrand(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/brand/remove`,
      method: "post",
      data,
    })
  ).data;
}

export async function importSellerNoReasonAfterSaleConfigSpu(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/spu/import`,
      method: "post",
      data,
    })
  ).data;
}

export async function getImportSellerNoReasonAfterSaleConfigSpuRecord(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/seller/noReasonAfterSaleConfig/import/record`,
      method: "post",
      data,
    })
  ).data;
}

export function downloadFileUrl(url) {
  return request({
    url,
    responseType: "blob",
  });
}
